<template>
  <basic-container>
    <avue-crud
        :option="option"
        :data="data"
        ref="crud"
        v-model="form"
        :permission="permissionList"
        :before-open="beforeOpen"
        @row-del="rowDel"
        @row-update="rowUpdate"
        @row-save="rowSave"
        @search-change="searchChange"
        @search-reset="searchReset"
        @refresh-change="refreshChange"
        @selection-change="selectionChange"
        :header-cell-class-name="headerCellClassName"
        @on-load="onLoad">
      <template slot="menuLeft">
        <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            v-if="permission.dict_delete"
            plain
            @click="handleDelete">删 除
        </el-button>
      </template>

    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDict, getList, remove, update } from '@/api/sys/dict'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      form: {},
      selectionList: [],
      headerCellClassName: 'headerClass',
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      params: {},
      option: {
        tip: false,
        border: true,
        index: true,
        selection: true,
        viewBtn: true,
        searchMenuSpan: 4,
        searchSpan: 4,
        column: [
          {
            label: '字典分类',
            prop: 'type',
            search: true,
            rules: [{
              required: true,
              message: '请输入字典编号'
            }]
          },
          {
            label: '字典键值',
            prop: 'dictKey',
            type: 'number',
            rules: [{
              required: true,
              message: '请输入字典键值'
            }]
          },
          {
            label: '字典名称',
            prop: 'dictValue',
            search: true,
            rules: [{
              required: true,
              message: '请输入字典名称'
            }]
          },
          {
            label: '字典排序',
            prop: 'sort',
            type: 'number',
            rules: [{
              required: true,
              message: '请输入字典排序'
            }]
          }
        ]
      },
      data: []
    }
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList () {
      return {
        addBtn: this.vaildData(this.permission.sys_dict_add, false),
        viewBtn: this.vaildData(this.permission.sys_dict_view, false),
        delBtn: this.vaildData(this.permission.sys_dict_delete, false),
        editBtn: this.vaildData(this.permission.sys_dict_edit, false)
      }
    },
    ids () {
      const ids = []
      this.selectionList.forEach(ele => {
        ids.push(ele.id)
      })
      return ids.join(',')
    }
  },
  methods: {
    rowSave (row, done) {
      add(row).then(() => {
        done()
        this.onLoad(this.page)
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      }, () => {
        done()
      })
    },
    rowUpdate (row, index, done) {
      update(row).then(() => {
        done()
        this.onLoad(this.page)
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      }, () => {
        done()
      })
    },
    rowDel (row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        remove(row.id).then(() => {
          this.onLoad(this.page)
        })
      })
    },

    handleDelete () {
      const _this = this
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据')
        return
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return remove(this.ids).then(() => {
          _this.onLoad(this.page)
          _this.$refs.crud.toggleSelection()
        })
      })
    },
    searchReset () {
      this.onLoad(this.page)
    },
    searchChange (params, done) {
      this.params = params
      this.onLoad(this.page, params, done)
    },
    selectionChange (list) {
      this.selectionList = list
    },

    refreshChange () {
      this.onLoad(this.page, this.params)
    },
    beforeOpen (done, type) {
      if (['edit', 'view'].includes(type)) {
        getDict(this.form.id).then(res => {
          this.form = res.data
        })
      }
      done()
    },
    onLoad (page, params = {}, done) {
      getList(page.currentPage, page.pageSize, params).then(res => {
        this.data = res.data.records
        if (done) {
          done()
        }
      })
    }
  }
}
</script>
<style>
.headerClass{
      background-color: #409EFF !important;
      color:#FFF !important;
    }
</style>
